import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  InputLabel,
  Select,
  Switch,
  Divider,
} from "@mui/material";
import { useSnackbar } from "notistack";
import CameraAltIcon from "@mui/icons-material/CameraAltOutlined";
import PersonIcon from "@mui/icons-material/PersonOutline";
import logo from "../../../src/assets/images/logoman.png";
import { baseUri, s3baseUri } from "../../config/config";
import CircularProgress from "@mui/material/CircularProgress";
import { useIds } from "../../hook/AdminContext";
import { useLocation } from "react-router-dom";
import { checkAndConvertToHTML, show_proper_words } from "../../utils/Constant";
import GeneralMuiModal from "../../components/modal/GeneralMuiModal";
import PageLoading from "../../components/loader/PageLoading";
import FormControl from "@mui/material/FormControl";

import {
  candidate_api_detail_fetch,
  candidate_edit_profile_api,
  client_detail_api,
  client_profile_edit_api,
  get_all_sectors_by_client_type,
} from "../../DAL/TalentSourceAPI/TalentSourceApi";
import TextEditor from "../../components/editors/ReactEditor";
import CropPopUp from "../../components/userslistToolbars/CCropPopUp";
import { CleaningServices } from "@mui/icons-material";
import FixedSizeImageCropper from "../../components/FixedSizeImageCropper/FixedSizeImageCropper";
import { combine_edit_profile_api } from "../../DAL/auth/auth";
import CircularLoader from "../../components/loader/CircularLoader";
import GeneralCkeditor from "../../components/editors/GeneralCkEditor";
import { get_client_details } from "../../DAL/clientTypes/ClientTpes";

const EditProfile = () => {
  const { enqueueSnackbar } = useSnackbar();
  const fileInputRef = useRef(null);
  const { setBreadCrumb, fetctUserDetail, userInfo } = useIds();

  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const [loading, setLoading] = useState(true);
  const [imageStatus, setImageStatus] = useState(false);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [imageRef, setImageRef] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [file, setFile] = useState(null);
  const [forcedWidth, setForcedWidth] = useState(0);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
    ]);
  }, []);

  const INITIAL_VALUES = {
    first_name: "",
    email: "",
    anchorEl: null,
    avatar: "",
    dialogOpen: false,
    loading: false,
    last_name: "",
    post_code: "",
    contact_number: "",
    status: true,
    company_name: "",
    contact_name: "",
    twitter_link: "",
    youtube: "",
    linkedIn_link: "",
    facebook_link: "",
    instagram_link: "",
    client_type: [""],
    sectorChoose: [],
    location: "",
    website: "",
    street_address: "",
    state: "",
    city: "",
    country: "",
    about: "",
    image: "",
    notification_settings: false,
    direct_contact: true,
    tagline: "",
    // Direct Contact fields
    direct_contact_full_name: "",
    direct_contact_job_title: "",
    direct_contact_email: "",
    direct_contact_phone: "",
    company_email: "",
  };

  const [inputs, setInputs] = useState(INITIAL_VALUES);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [sectors, setSectors] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [previews, setPreviews] = useState("");
  const [oldProfile, setOldProfile] = useState();
  const { setProfileNewImage, setUserInfo } = useIds();
  const [openPopUp, setOpenPopUp] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [crop, setCrop] = useState({
    unit: "%",
    width: 95,
    height: 95,
    x: 2.5,
    y: 2.5,
  });

  const getSectorObj = (clientTypes) => {
    if (!clientTypes || !Array.isArray(clientTypes)) return [];

    return clientTypes
      .map((clientTypeObj) => {
        return {
          client_type: clientTypeObj?.slug || "",
          sector_id: clientTypeObj?.sector?.slug || "",
        };
        // Extract client type slug from the object structure
        let clientTypeSlug;
        if (typeof clientTypeObj === "string") {
          clientTypeSlug = clientTypeObj;
        } else if (clientTypeObj && typeof clientTypeObj === "object") {
          clientTypeSlug =
            clientTypeObj.slug ||
            clientTypeObj._id ||
            clientTypeObj.title?.toLowerCase().replace(/\s+/g, "_");
        } else {
          return null;
        }

        if (!clientTypeSlug) return null;

        // First try to get sector from clientTypeObj.sector (existing data)
        let sectorId = "";
        if (
          clientTypeObj &&
          typeof clientTypeObj === "object" &&
          clientTypeObj.sector
        ) {
          if (clientTypeObj.sector.sector_id) {
            sectorId = clientTypeObj.sector.sector_id;
          }
        }

        // If no sector from clientTypeObj, try to get from sectors array
        if (!sectorId) {
          const sectorData = sectors?.find(
            (sector) => sector.client_type === clientTypeSlug
          );

          // Handle both formats: sector_id as object with _id or direct string
          if (sectorData?.sector_id) {
            if (
              typeof sectorData.sector_id === "object" &&
              sectorData.sector_id._id
            ) {
              sectorId = sectorData.sector_id._id;
            } else if (typeof sectorData.sector_id === "string") {
              sectorId = sectorData.sector_id;
            }
          }
        }

        return {
          client_type: clientTypeSlug,
          sector_id: sectorId,
        };
      })
      .filter((item) => item !== null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((old) => ({ ...old, [name]: value }));
  };

  const fetchSectors = async (obj) => {
    const clientTypes = obj?.client_type || [];
    if (clientTypes.length === 0) {
      setLoading(false);
      return;
    }

    setLoading(true);

    try {
      // Helper to normalize slug
      const getSlug = (clientTypeObj) => {
        if (typeof clientTypeObj === "string") return clientTypeObj;
        if (clientTypeObj && typeof clientTypeObj === "object") {
          return (
            clientTypeObj.slug ||
            clientTypeObj.title?.toLowerCase().replace(/\s+/g, "_")
          );
        }
        return null;
      };

      // Prepare API calls
      const requests = clientTypes
        .map((obj) => getSlug(obj))
        .filter(Boolean) // remove nulls
        .map(async (slug) => {
          try {
            const response = await get_all_sectors_by_client_type(
              "",
              50,
              0,
              slug
            );

            if (response.code === 200) {
              return { slug, sectors: response?.data?.sectors || [] };
            } else {
              enqueueSnackbar(`Failed to fetch sectors for ${slug}`, {
                variant: "error",
              });
              return { slug, sectors: [] };
            }
          } catch (err) {
            console.error(`Error fetching ${slug}:`, err);
            enqueueSnackbar(`Error fetching sectors for ${slug}`, {
              variant: "error",
            });
            return { slug, sectors: [] };
          }
        });

      // Run all in parallel
      const results = await Promise.all(requests);

      // Build object
      const sectorsData = results.reduce((acc, { slug, sectors }) => {
        acc[slug] = sectors;
        return acc;
      }, {});

      setInputs((prev) => ({
        ...prev,
        clientTypeHavingSectors: getClientTypeHavingSectors(sectorsData, obj),
      }));

      setSectors(sectorsData);
    } catch (error) {
      enqueueSnackbar("Error fetching sectors", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleSectorChange = (slug, newSectorId) => {
    setInputs((prev) => ({
      ...prev,
      clientTypeHavingSectors: prev.clientTypeHavingSectors.map((clientType) =>
        clientType.slug === slug
          ? {
              ...clientType,
              sector: {
                ...clientType.sector,
                slug: newSectorId,
              },
            }
          : clientType
      ),
    }));
  };

  const getClientTypeHavingSectors = (sectorObj, profileObj) => {
    // Step 1: filter client types that have sector arrays in sectorObj
    let typeArrayWithSector = (profileObj?.client_type || []).filter(
      (obj) => sectorObj[obj.slug]?.length > 0
    );

    // Step 2: enrich sector only if slug is missing
    return typeArrayWithSector.map((clientType) => {
      const hasSlug = clientType.sector?.slug;

      if (!hasSlug) {
        const matchedSector = sectorObj[clientType.slug]?.find(
          (s) => s._id === clientType.sector?.sector_id
        );

        if (matchedSector) {
          return {
            ...clientType,
            sector: {
              ...clientType.sector,
              slug: matchedSector.slug,
            },
          };
        } else {
          return {
            ...clientType,
            sector: {
              ...clientType.sector,
              slug: "",
            },
          };
        }
      }

      return clientType; // unchanged if slug already exists or no match
    });
  };

  const handleMenuOpen = (event) => {
    setInputs((old) => ({ ...old, anchorEl: event.currentTarget }));
  };

  const handleMenuClose = () => {
    setInputs((old) => ({ ...old, anchorEl: null }));
  };

  const handleUpdateImage = () => {
    fileInputRef.current.click();
    handleMenuClose();
  };

  const handleViewProfile = () => {
    setInputs((old) => ({ ...old, dialogOpen: true }));
    handleMenuClose();
  };

  const handleDialogClose = () => {
    setInputs((old) => ({ ...old, dialogOpen: false }));
  };

  const fileChangedHandler = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Handle SVG files differently
    if (file.type === "image/svg+xml") {
      const reader = new FileReader();
      reader.onload = () => {
        // Directly set the SVG as preview and file
        setCroppedImage(reader.result);
        setInputs((prev) => ({ ...prev, image: file }));
      };
      reader.readAsDataURL(file);
      return; // Skip the cropping modal for SVG
    }

    // Original handling for other image types
    const reader = new FileReader();
    reader.onload = () => {
      setFile(reader.result);
      setCropModalOpen(true);
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  const hasImage = (string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(string, "text/html");
    return doc.querySelector("img") !== null;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (inputs.about) {
      if (hasImage(inputs.about)) {
        enqueueSnackbar("About section should not contain images", {
          variant: "error",
        });
        return;
      }
    }

    // URL validation function
    const validateUrl = (url) => {
      if (url && !/^https?:\/\//i.test(url)) {
        return false; // Invalid URL
      }
      return true; // Valid URL
    };

    const invalidUrls = [];
    if (inputs.facebook_link && !validateUrl(inputs.facebook_link))
      invalidUrls.push("Facebook");
    if (inputs.instagram_link && !validateUrl(inputs.instagram_link))
      invalidUrls.push("Instagram");
    if (inputs.linkedIn_link && !validateUrl(inputs.linkedIn_link))
      invalidUrls.push("LinkedIn");
    if (inputs.website && !validateUrl(inputs.website))
      invalidUrls.push("Website");
    if (inputs.youtube && !validateUrl(inputs.youtube))
      invalidUrls.push("YouTube");
    if (inputs.twitter_link && !validateUrl(inputs.twitter_link))
      invalidUrls.push("Twitter");

    if (invalidUrls.length > 0) {
      enqueueSnackbar(
        `Please add a valid URL with https:// for: ${invalidUrls.join(", ")}`,
        { variant: "error" }
      );
      setIsUpdating(false);
      return;
    }

    // Role-based validation
    if (userInfo.role === "client" || userInfo?.isCompanyProfile) {
      if (inputs.tagline?.length > 120) {
        enqueueSnackbar("Tagline must be 120 characters or less.", {
          variant: "error",
        });
        return;
      }
      if (!inputs.about) {
        enqueueSnackbar("About Yourself is required.", { variant: "error" });
        return;
      }

      // Check if any client type requires sector selection
      if (inputs?.clientTypeHavingSectors?.length > 0) {
        const hasSelectedSectors = inputs?.clientTypeHavingSectors.every(
          (clientType) => {
            return clientType.sector && clientType.sector.slug;
          }
        );

        if (!hasSelectedSectors) {
          enqueueSnackbar(
            "Sector selection is required for all applicable client types",
            { variant: "error" }
          );
          return;
        }
      }
      // Check if there's a new image upload OR existing image in userInfo
      const hasNewImage = inputs.image && typeof inputs.image !== "string";
      const hasExistingImage = croppedImage;

      if (!hasNewImage && !hasExistingImage) {
        enqueueSnackbar("Profile image is required.", { variant: "error" });
        return;
      }

      // Validate Direct Contact fields if direct_contact is enabled
      if (inputs.direct_contact) {
        if (!inputs.direct_contact_full_name?.trim()) {
          enqueueSnackbar("Direct Contact Full Name is required.", {
            variant: "error",
          });
          return;
        }
        if (!inputs.direct_contact_job_title?.trim()) {
          enqueueSnackbar("Direct Contact Job Title is required.", {
            variant: "error",
          });
          return;
        }
        if (!inputs.direct_contact_email?.trim()) {
          enqueueSnackbar("Direct Contact Email Address is required.", {
            variant: "error",
          });
          return;
        }
        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(inputs.direct_contact_email)) {
          enqueueSnackbar(
            "Please enter a valid email address for Direct Contact.",
            { variant: "error" }
          );
          return;
        }
      }
    }

    setIsUpdating(true);
    setInputs((old) => ({ ...old, loading: true }));

    const formData = new FormData();

    // Role-based form data preparation
    if (userInfo?.role === "client" || userInfo?.isCompanyProfile) {
      // Client form data
      formData.append("company_name", inputs.company_name);
      formData.append("contact_number", inputs.contact_number);
      formData.append("post_code", inputs.post_code);
      formData.append("status", true);
      formData.append("linkedin", inputs.linkedIn_link);
      formData.append("youtube", inputs.youtube);
      formData.append("twitter", inputs.twitter_link);
      formData.append("instagram", inputs.instagram_link);
      formData.append("facebook", inputs.facebook_link);
      formData.append("contact_name", inputs.contact_name);
      formData.append("location", inputs.location);
      formData.append("website_url", inputs.website);
      formData.append("about", inputs.about);
      formData.append("email_notification", inputs.notification_settings);
      formData.append("direct_contact_enabled", inputs.direct_contact);
      formData.append("role", "client");
      formData.append("tagline", inputs.tagline || "");

      formData.append("client_type", getClientType());

      if (inputs.direct_contact) {
        const directContactObj = {
          full_name: inputs.direct_contact_full_name,
          job_title: inputs.direct_contact_job_title,
          email_address: inputs.direct_contact_email,
          company_email: inputs.company_email,
          phone_number: inputs.direct_contact_phone || "",
        };
        formData.append("direct_contact", JSON.stringify(directContactObj));
      }

      if (inputs.image instanceof File) {
        formData.append("image", inputs.image);
      }
    } else {
      // Candidate form data
      formData.append("first_name", inputs.first_name);
      formData.append("last_name", inputs.last_name);
      formData.append("contact_number", inputs.contact_number);
      formData.append("post_code", inputs.post_code);
      formData.append("status", true);
      formData.append("street", inputs.street_address);
      formData.append("state", inputs.state);
      formData.append("city", inputs.city);
      formData.append("country", inputs.country);
      formData.append("role", userInfo.role);
      if (inputs.image instanceof File) {
        formData.append("image", inputs.image);
      }
    }

    try {
      let response;

      if (userInfo?.role === "client" || userInfo?.isCompanyProfile) {
        response = await combine_edit_profile_api(
          userInfo?.profile_id,
          formData
        );
      } else {
        response = await combine_edit_profile_api(userInfo?._id, formData);
      }

      if (response?.code === 200) {
        let data;
        if (response.data?.client) {
          data = { ...response.data.client };
        } else if (response.data) {
          data = { ...response.data };
        } else if (response?.customer) {
          data = { ...response.customer };
        } else {
          data = {};
        }

        const currentUser = JSON.parse(localStorage.getItem("user"));
        const updatedData = {
          ...data,
          is_temporary_password:
            currentUser.is_temporary_password === false
              ? false
              : data.is_temporary_password,
        };

        if (!userInfo?.isCompanyProfile) {
          setInputs((old) => ({ ...old, ...data }));
          localStorage.setItem("user", JSON.stringify(updatedData));
          fetctUserDetail();
          setUserInfo(updatedData);
        }
        enqueueSnackbar(response.message, { variant: "success" });

        // Force immediate image update
        setTimeout(() => {
          if (updatedData.profile_image?.thumbnail_1) {
            const imageUrl = s3baseUri + updatedData.profile_image?.thumbnail_1;
            setCroppedImage(imageUrl);
            setInputs((old) => ({
              ...old,
              image: updatedData.profile_image?.thumbnail_1,
            }));
          } else if (
            updatedData.profile_image &&
            typeof updatedData.profile_image === "string"
          ) {
            const imageUrl = s3baseUri + updatedData.profile_image;
            setCroppedImage(imageUrl);
            setInputs((old) => ({
              ...old,
              image: updatedData.profile_image,
            }));
          }
        }, 100);
      } else {
        enqueueSnackbar(response?.message || "Something went wrong", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar("Network error. Please try again.", { variant: "error" });
    } finally {
      setIsUpdating(false);
    }
  };
  const getClientType = () => {
    if (!Array.isArray(inputs?.client_type)) return "[]";

    const mapped = inputs.client_type.map((obj) => {
      // find matching client type in clientTypeHavingSectors by slug
      const match = inputs.clientTypeHavingSectors?.find(
        (ct) => ct.slug === obj.slug
      );

      return {
        slug: obj.slug,
        sector_slug: match?.sector?.slug || obj?.sector?.slug || "",
      };
    });

    return JSON.stringify(mapped);
  };

  const handleSetInputs = (obj) => {
    if (obj) {
      setInputs((old) => ({
        ...old,
        ...obj,
        // Client fields
        company_name: obj?.company_name || "",
        contact_name: obj?.contact_name || "",
        contact_number: obj?.contact_number || "",
        post_code: obj?.address?.post_code || obj?.post_code || "",
        location: obj?.location || "",
        website: obj?.website_url || obj?.website || "",
        about: checkAndConvertToHTML(obj?.about) || "",
        // image: obj?.profile_image?.thumbnail_1 || "",
        notification_settings: obj?.email_notification || false,
        direct_contact: obj?.direct_contact_enabled,
        // Social links
        instagram_link: obj?.social_links?.instagram || "",
        facebook_link: obj?.social_links?.facebook || "",
        twitter_link: obj?.social_links?.twitter || "",
        linkedIn_link: obj?.social_links?.linkedin || "",
        youtube: obj?.social_links?.youtube || "",
        // Direct contact fields
        direct_contact_full_name: obj?.direct_contact?.full_name || "",
        direct_contact_job_title: obj?.direct_contact?.job_title || "",
        direct_contact_email: obj?.direct_contact?.email_address || "",
        company_email: obj?.direct_contact?.company_email || "",
        direct_contact_phone: obj?.direct_contact?.phone_number || "",
        // Candidate fields
        first_name: obj?.first_name || "",
        last_name: obj?.last_name || "",
        street_address: obj?.address?.street || "",
        city: obj?.address?.city || "",
        state: obj?.address?.state || obj?.state || "",
        country: obj?.address?.country || "",
        // Sectors
      }));

      if (obj?.profile_image?.thumbnail_1) {
        const imageUrl =
          s3baseUri + obj.profile_image?.thumbnail_1 + "?t=" + Date.now();
        setCroppedImage(imageUrl);
      } else if (obj?.profile_image && typeof obj.profile_image === "string") {
        const imageUrl = s3baseUri + obj.profile_image + "?t=" + Date.now();
        setCroppedImage(imageUrl);
      } else {
        setCroppedImage(null);
      }

      if (obj?.client_type) {
        fetchSectors(obj);
      }
    }
  };

  const handleGetClientDetails = async () => {
    const resp = await get_client_details(userInfo.profile_id);
    if (resp.code == 200) {
      handleSetInputs(resp.user);
    } else {
      setLoading(false);
      enqueueSnackbar(resp.message, { variant: "error" });
    }
  };

  useEffect(() => {
    if (userInfo?.isCompanyProfile) {
      handleGetClientDetails();
    } else {
      handleSetInputs(userInfo);
    }
  }, [userInfo]);

  useEffect(() => {
    const custom_width = document.querySelector(".right-section")?.offsetWidth;
    if (forcedWidth === 0) {
      setForcedWidth(custom_width);
    }
  }, []);

  if (loading) {
    return <CircularLoader />;
  }

  return (
    <div style={{ maxWidth: forcedWidth }} className="ps-2">
      {cropModalOpen && (
        <>
          <FixedSizeImageCropper
            image={file}
            maxSize={{ width: 1080, height: 1080 }}
            onClose={() => setCropModalOpen(false)}
            aspectRatio={1 / 1}
            handleCropComplete={(file) => {
              setCroppedImage(URL.createObjectURL(file));
              setInputs((prev) => ({ ...prev, image: file }));
              setCropModalOpen(false);
            }}
            roundCropAreaPixels={true}
            open={cropModalOpen}
          />
        </>
      )}

      <div className="contaner-fluid">
        <GeneralMuiModal
          open={inputs.dialogOpen}
          setOpen={handleDialogClose}
          componentToPass={
            <>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  className="de-flex text-center justify-cotent-center"
                  alt="Profile"
                  src={
                    croppedImage ||
                    (inputs.image && typeof inputs.image === "string"
                      ? s3baseUri + inputs.image
                      : "")
                  }
                  style={{ width: 200, height: 200, margin: "0 auto" }}
                />
              </div>
            </>
          }
        />
        <div style={{ display: "flex", justifyContent: "center" }}></div>
      </div>

      {/* Client Profile Form */}
      {(userInfo?.role === "client" || userInfo?.isCompanyProfile) && (
        <div className="d-flex justify-content-center mt-4">
          <div className="card-1 d-block edit-profile-card p-1">
            <h3 className="p-3">Profile Settings</h3>

            <div className="d-flex edit-profle-image mt-3">
              <Avatar
                key={croppedImage || inputs.image || "default"}
                alt="Profile Picture"
                src={
                  croppedImage ||
                  (inputs.image && typeof inputs.image === "string"
                    ? s3baseUri + inputs.image
                    : "")
                }
                sx={{ width: 100, height: 100, mb: 2 }}
              />

              <IconButton
                color="primary"
                aria-controls="profile-menu"
                aria-haspopup="true"
                onClick={handleMenuOpen}
                sx={{
                  bgcolor: "white",
                  color: "navy",
                  borderRadius: "50%",
                  bottom: "50px",
                  left: "40px",
                  "&:hover": {
                    color: "navy",
                    backgroundColor: "white",
                  },
                  "&:focus": {
                    color: "navy",
                    backgroundColor: "white !important",
                  },
                }}
              >
                <CameraAltIcon />
              </IconButton>

              <Menu
                id="profile-menu"
                anchorEl={inputs.anchorEl}
                open={Boolean(inputs.anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <MenuItem onClick={handleUpdateImage}>
                  <ListItemIcon>
                    <CameraAltIcon fontSize="small" />
                  </ListItemIcon>
                  Update Image
                </MenuItem>
                <MenuItem onClick={handleViewProfile}>
                  <ListItemIcon>
                    <PersonIcon fontSize="small" />
                  </ListItemIcon>
                  View Image
                </MenuItem>
              </Menu>
              <input
                hidden
                accept="image/jpeg, image/jpg, image/png, image/webp"
                type="file"
                ref={fileInputRef}
                onChange={fileChangedHandler}
              />
            </div>

            <form component="form" onSubmit={handleSubmit} sx={{ mt: 0 }}>
              <div className=" container">
                <div className="row">
                  <div className="col-md-6 ">
                    <TextField
                      fullWidth
                      margin="normal"
                      required
                      id="company_name"
                      label="Company Name"
                      name="company_name"
                      value={inputs.company_name}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <TextField
                      required
                      fullWidth
                      margin="normal"
                      id="contact_name"
                      label="Contact Name"
                      name="contact_name"
                      type="text"
                      value={inputs.contact_name}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <TextField
                      fullWidth
                      margin="normal"
                      required
                      id="post_code"
                      label="Postal Code"
                      name="post_code"
                      type="text"
                      value={inputs.post_code}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                  <div className="col-md-6 ">
                    <TextField
                      fullWidth
                      required
                      margin="normal"
                      id="contact_number"
                      label="Contact Number"
                      name="contact_number"
                      type="number"
                      value={inputs.contact_number}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 ">
                    <TextField
                      fullWidth
                      margin="normal"
                      required
                      id="Location"
                      label="Location"
                      name="location"
                      type="text"
                      value={inputs.location}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <TextField
                      fullWidth
                      margin="normal"
                      id="website"
                      label="Website"
                      name="website"
                      type="text"
                      value={inputs.website}
                      required
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 ">
                    <TextField
                      fullWidth
                      margin="normal"
                      id="youtube"
                      label="Youtube Link"
                      name="youtube"
                      type="text"
                      value={inputs.youtube}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                  <div className="col-md-6 ">
                    <TextField
                      fullWidth
                      margin="normal"
                      id="linkedIn_link"
                      label="LinkedIn Link"
                      name="linkedIn_link"
                      type="text"
                      value={inputs.linkedIn_link}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 ">
                    <TextField
                      fullWidth
                      margin="normal"
                      id="instagram_link"
                      label="Instagram Link"
                      name="instagram_link"
                      type="text"
                      value={inputs.instagram_link}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                  <div className="col-md-6 ">
                    <TextField
                      fullWidth
                      margin="normal"
                      id="facebook_link"
                      label="Facebook Link"
                      name="facebook_link"
                      type="text"
                      value={inputs.facebook_link}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <TextField
                      fullWidth
                      margin="normal"
                      id="twitter_link"
                      label="Twitter Link"
                      name="twitter_link"
                      type="text"
                      value={inputs.twitter_link}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                  {/* Dynamic Sector Fields based on Client Types */}
                  {(() => {
                    // Show sectors when we have data from API
                    return inputs?.clientTypeHavingSectors?.map(
                      (clientType, index) => {
                        // Use title from original object, fallback to formatted clientType
                        const labelText = clientType.title;

                        return (
                          <div className="col-md-6 mt-3 mb-2">
                            <FormControl
                              fullWidth
                              required
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "50px",
                                  borderRadius: "6px",
                                  textAlign: "left",
                                },
                              }}
                            >
                              <InputLabel
                                id={`sector-select-${clientType._id}`}
                              >
                                {labelText} Sector
                              </InputLabel>
                              <Select
                                labelId={`sector-select-${clientType._id}`}
                                id={`sector-select-${clientType._id}`}
                                value={clientType.sector.slug}
                                label={`${labelText} Sector`}
                                onChange={(e) =>
                                  handleSectorChange(
                                    clientType.slug,
                                    e.target.value
                                  )
                                }
                              >
                                {(() => {
                                  const options = [];
                                  // Add other sectors from API
                                  if (sectors[clientType.slug]) {
                                    sectors[clientType.slug].forEach(
                                      (sector) => {
                                        options.push(
                                          <MenuItem
                                            key={sector.slug}
                                            value={sector.slug}
                                          >
                                            {sector.title}
                                          </MenuItem>
                                        );
                                      }
                                    );
                                  }

                                  return options;
                                })()}
                              </Select>
                            </FormControl>
                          </div>
                        );
                      }
                    );
                  })()}
                </div>

                <div className="col-md-12">
                  <TextField
                    fullWidth
                    margin="normal"
                    id="tagline"
                    label="Tagline"
                    name="tagline"
                    multiline
                    rows={3}
                    value={inputs.tagline}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 121) {
                        handleChange(e);
                      }
                    }}
                    error={inputs.tagline?.length > 120}
                    helperText={
                      inputs.tagline?.length > 120
                        ? "Tagline cannot exceed 120 characters"
                        : `${inputs.tagline?.length || 0}/120 characters`
                    }
                    inputProps={{ maxLength: 121 }} // allow 1 extra to trigger error UI
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "6px",
                      },
                    }}
                  />
                </div>

                <h6 className="mt-3" style={{ textAlign: "left" }}>
                  About Yourself *
                </h6>
                <div style={{ flex: 1 }}>
                  {/* <TextEditor
                    required
                    inputs={inputs}
                    setInputs={setInputs}
                    name="about"
                    type="about"
                    isLimited={true}
                  /> */}
                  <GeneralCkeditor
                    inputs={inputs}
                    setInputs={setInputs}
                    name="about"
                  />
                </div>
                <div className="mt-4 mb-4">
                  <Divider />
                </div>
                <h4
                  style={{
                    fontWeight: "bold",
                    marginBottom: "12px",
                    textAlign: "left",
                  }}
                >
                  Notification Settings
                </h4>

                <div className="col-lg-12 col-sm-12 mt-2">
                  <div
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      padding: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        Job Application Notifications
                      </span>
                      <Switch
                        color="primary"
                        inputProps={{ "aria-label": "Enable Email Alerts" }}
                        checked={inputs.notification_settings}
                        onChange={(event) => {
                          setInputs((prev) => ({
                            ...prev,
                            notification_settings: event.target.checked,
                          }));
                        }}
                      />
                    </div>

                    <p
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                        color: "#555",
                        textAlign: "left",
                      }}
                    >
                      Receive an email alert whenever a candidate applies to one
                      of your job postings. The email will include the
                      candidate's name, email, CV and the job title they applied
                      for. You can turn these alerts on or off anytime.
                    </p>
                  </div>
                </div>
                <div className="mt-4 mb-4">
                  <Divider />
                </div>

                <h4
                  style={{
                    fontWeight: "bold",
                    marginBottom: "12px",
                    textAlign: "left",
                  }}
                >
                  Direct Contact details{" "}
                </h4>

                <div className="col-lg-12 col-sm-12 mt-2 mb-1">
                  <div
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      padding: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                        Share Direct Contact Information
                      </span>
                      <Switch
                        color="primary"
                        inputProps={{ "aria-label": "Enable Email Alerts" }}
                        checked={inputs.direct_contact}
                        onChange={(event) => {
                          setInputs((prev) => ({
                            ...prev,
                            direct_contact: event.target.checked,
                          }));
                        }}
                      />
                    </div>

                    <p
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                        color: "#555",
                        textAlign: "left",
                      }}
                    >
                      Provide your direct contact information to display on your
                      public profile, allowing users to reach you directly. You
                      may also choose to disable this option if you prefer not
                      to share your contact details.
                    </p>
                    {inputs.direct_contact && (
                      <div style={{ marginTop: "20px" }}>
                        <h5
                          style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                            textAlign: "start",
                            marginBottom: "1px",
                          }}
                        >
                          Direct Contact Information
                        </h5>

                        <div className="row">
                          <div className="col-md-6">
                            <TextField
                              fullWidth
                              margin="normal"
                              required
                              id="direct_contact_full_name"
                              label="Full Name"
                              name="direct_contact_full_name"
                              type="text"
                              value={inputs.direct_contact_full_name}
                              onChange={handleChange}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "50px",
                                  borderRadius: "6px",
                                },
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <TextField
                              fullWidth
                              margin="normal"
                              required
                              id="direct_contact_job_title"
                              label="Job Title"
                              name="direct_contact_job_title"
                              type="text"
                              value={inputs.direct_contact_job_title}
                              onChange={handleChange}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "50px",
                                  borderRadius: "6px",
                                },
                              }}
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <TextField
                              fullWidth
                              margin="normal"
                              required
                              id="direct_contact_email"
                              label="Email Address"
                              name="direct_contact_email"
                              type="email"
                              value={inputs.direct_contact_email}
                              onChange={handleChange}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "50px",
                                  borderRadius: "6px",
                                },
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <TextField
                              fullWidth
                              margin="normal"
                              id="company_email"
                              label="Company Email Address"
                              name="company_email"
                              type="email"
                              value={inputs.company_email}
                              onChange={handleChange}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "50px",
                                  borderRadius: "6px",
                                },
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <TextField
                              fullWidth
                              margin="normal"
                              id="direct_contact_phone"
                              label="Phone Number (Optional)"
                              name="direct_contact_phone"
                              type="number"
                              value={inputs.direct_contact_phone}
                              onChange={handleChange}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "50px",
                                  borderRadius: "6px",
                                },
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="container d-flex justify-content-end mb-3 mt-3">
                <button className="theme-button-contained" type="submit">
                  {isUpdating ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Candidate / internal user Profile Form */}
      {(userInfo?.role === "candidate" || userInfo?.role === "internal_user") &&
        !userInfo?.isCompanyProfile && (
          <div className="d-flex justify-content-center mt-4">
            <div className="card-1 d-block edit-profile-card p-1">
              <div className="d-flex edit-profle-image mt-3">
                <Avatar
                  key={croppedImage || inputs.image || "default"}
                  alt="Profile Picture"
                  src={
                    croppedImage ||
                    (inputs.image && typeof inputs.image === "string"
                      ? s3baseUri + inputs.image
                      : "")
                  }
                  sx={{ width: 100, height: 100, mb: 2 }}
                />
                <IconButton
                  color="primary"
                  aria-controls="profile-menu"
                  aria-haspopup="true"
                  onClick={handleMenuOpen}
                  sx={{
                    bgcolor: "white",
                    color: "navy",
                    borderRadius: "50%",
                    bottom: "50px",
                    left: "40px",
                    "&:hover": {
                      color: "navy",
                      backgroundColor: "white",
                    },
                    "&:focus": {
                      color: "navy",
                      backgroundColor: "white !important",
                    },
                  }}
                >
                  <CameraAltIcon />
                </IconButton>
                <Menu
                  id="profile-menu"
                  anchorEl={inputs.anchorEl}
                  open={Boolean(inputs.anchorEl)}
                  onClose={handleMenuClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                >
                  <MenuItem onClick={handleUpdateImage}>
                    <ListItemIcon>
                      <CameraAltIcon fontSize="small" />
                    </ListItemIcon>
                    {croppedImage || inputs.image
                      ? "Update Image"
                      : "Upload Image"}
                  </MenuItem>
                  {(croppedImage || inputs.image) && (
                    <MenuItem onClick={handleViewProfile}>
                      <ListItemIcon>
                        <PersonIcon fontSize="small" />
                      </ListItemIcon>
                      View Image
                    </MenuItem>
                  )}
                </Menu>
                <input
                  hidden
                  accept="image/jpeg, image/jpg, image/png, image/webp"
                  type="file"
                  ref={fileInputRef}
                  onChange={fileChangedHandler}
                />
              </div>

              <form component="form" onSubmit={handleSubmit} className="p-3">
                <div className="container">
                  <div style={{ display: "flex", gap: "10px" }}>
                    <TextField
                      fullWidth
                      margin="normal"
                      required
                      id="first_name"
                      label="First Name"
                      name="first_name"
                      value={inputs.first_name}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      margin="normal"
                      required
                      id="last_name"
                      label="Last Name"
                      name="last_name"
                      value={inputs.last_name}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>

                  <div style={{ display: "flex", gap: "10px" }}>
                    <TextField
                      fullWidth
                      margin="normal"
                      required
                      id="contact_number"
                      label="Contact Number"
                      name="contact_number"
                      type="number"
                      value={inputs.contact_number}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      margin="normal"
                      id="post_code"
                      label="Postal Code"
                      name="post_code"
                      type="text"
                      value={inputs.post_code}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>

                  <div style={{ display: "flex", gap: "10px" }}>
                    <TextField
                      fullWidth
                      margin="normal"
                      id="country"
                      label="Country"
                      name="country"
                      value={inputs.country}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      margin="normal"
                      id="street_address"
                      label="Street Address"
                      name="street_address"
                      value={inputs.street_address}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>

                  <div style={{ display: "flex", gap: "10px" }}>
                    <TextField
                      fullWidth
                      margin="normal"
                      id="city"
                      label="City"
                      name="city"
                      value={inputs.city}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                    <TextField
                      fullWidth
                      margin="normal"
                      id="state"
                      label="State"
                      name="state"
                      value={inputs.state}
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "50px",
                          borderRadius: "6px",
                        },
                      }}
                    />
                  </div>
                </div>

                <div className="container d-flex justify-content-end mb-3 mt-3">
                  <button className="theme-button-contained" type="submit">
                    {isUpdating ? "Updating..." : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
    </div>
  );
};

export default EditProfile;
